import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import { transactionDetailsDialogAtom } from '@root/entities/transaction/atoms'
import { TransactionDetailsDrawer } from '@root/entities/transaction/ui/transaction-details-drawer'

type Props = {}

export const TransactionDetailsDrawerController: React.FC<Props> = () => {
  const [activeTransaction, setActiveTransaction] = useAtom(
    transactionDetailsDialogAtom,
  )
  return (
    <>
      <AnimatePresence>
        {activeTransaction ? (
          <TransactionDetailsDrawer
            tx={activeTransaction}
            open={true}
            onOpenChange={(open) => {
              if (!open) {
                setActiveTransaction(undefined)
              }
            }}
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
}
